import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { Text } from "@dhxete/text";
const Div = styled.div`
  display: flex;
`;
const Span = styled.span`
  font-size: 12px;
  margin-right: 3px;
  position: relative;
  top: 3px;
`;

const Circle = ({
  isAgentAvailable,
  langStrings
}) => /*#__PURE__*/React.createElement(Div, null, /*#__PURE__*/React.createElement(Span, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
  color: isAgentAvailable ? "#7ccc13" : "#f5b723",
  icon: faCircle
})), /*#__PURE__*/React.createElement(Text, null, isAgentAvailable ? langStrings.contactOptions.agentAvailable : langStrings.contactOptions.agentUnavailable));

Circle.propTypes = {
  isAgentAvailable: PropTypes.bool,
  langStrings: PropTypes.object
};
export default Circle;